import React from 'react';
import { getOr } from 'lodash/fp';
import FileValueCell from '../CustomCells/FileValueCell';
import { OUTREACH_AGGREGATE } from '../../../helpers/ReportTemplateTypes';
import {
  NEW_BY_LABELS,
  REPORT_BY_LABELS,
  REPORT_AS_LABELS
} from '../../../helpers/constants';

const extraColumnsByType = {
  [OUTREACH_AGGREGATE]: [
    {
      width: 100,
      title: 'Report Type',
      cell: <FileValueCell dataKey="reportType" valueLabel={REPORT_BY_LABELS} />
    },
    {
      width: 160,
      title: 'First Time By',
      cell: <FileValueCell dataKey="firstTimeBy" valueLabel={NEW_BY_LABELS} />
    },
    {
      width: 150,
      title: 'Result for',
      cell: <FileValueCell dataKey="reportAs" valueLabel={REPORT_AS_LABELS} />
    }
  ]
};

export default type => getOr([], type, extraColumnsByType);
